import { useEffect } from "react";

export const Video = (props: any) => {
  const { item, setVideo, video } = props;

  useEffect(() => {
    setVideo({
      ...video,
      view: false,
      exist: true,
      code: item.VideoFrame,
      caption: "",
    });
  }, [item]);

  return <></>;
};

export default Video;
